import * as store from '@daas-consulting/core-frontend-store';
import { StateToken } from '@ngxs/store';
import { context, feature } from '../audit.const';
import { AuditDetailPreviewStateModel as Model } from './audit-detail_preview.state-model';

const name = store.getName({
  context,
  feature,
  section: store.SectionsNames.detailPreview,
});
export const stateTokenName = new StateToken<Model>(name);
